import * as z from 'zod';

export const updateNewProductSchema = z.object({
  name: z
    .string()
    .trim()
    .min(1, { message: 'Product name should not be empty.' }),
  description: z
    .string()
    .trim()
    // match backend validation
    .min(3, { message: 'Product description should be at least 3 characters long.' }),
  taxCode: z
    .string()
    .trim()
    .min(1, { message: 'Product tax code should not be empty.' }),
});

export type UpdateProductFormFields = z.infer<typeof updateNewProductSchema>;
